/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';

import { EVehicleSelectionMode } from '../../models';

export enum EVehicleListPanelActions {
  CloseScopingDialog = '[Vehicle List] Close Scoping Dialog',
  FocusVehicle = '[Vehicle List] Focus Vehicle',
  FocusAsset = '[Vehicle List] Focus Asset',
  OpenScopingDialog = '[Vehicle List] Open Scoping Dialog',
  SelectVehicle = '[Vehicle List] Select Vehicle',
  SelectAndFocusVehicle = '[Vehicle List] Select And Focus Vehicle',
  SelectAsset = '[Vehicle List] Select Asset',
  UpdateVehicleSelectionMode = '[Vehicle List] Update Selection Mode'
}

export class CloseScopingDialog implements Action {
  public readonly type = EVehicleListPanelActions.CloseScopingDialog;
}

export class FocusVehicle implements Action {
  public readonly type = EVehicleListPanelActions.FocusVehicle;

  constructor(public payload: string) {}
}

export class FocusAsset implements Action {
  public readonly type = EVehicleListPanelActions.FocusAsset;

  constructor(public payload: string) {}
}

export class OpenScopingDialog implements Action {
  public readonly type = EVehicleListPanelActions.OpenScopingDialog;
}

export class SelectVehicle implements Action {
  public readonly type = EVehicleListPanelActions.SelectVehicle;

  constructor(public payload: string) {}
}

export class SelectAndFocusVehicle implements Action {
  public readonly type = EVehicleListPanelActions.SelectAndFocusVehicle;

  constructor(public payload: string) {}
}

export class SelectAsset implements Action {
  public readonly type = EVehicleListPanelActions.SelectAsset;

  constructor(public payload: string) {}
}

export class UpdateVehicleSelectionMode implements Action {
  public readonly type = EVehicleListPanelActions.UpdateVehicleSelectionMode;

  constructor(public payload: EVehicleSelectionMode) {}
}

export type VehicleListPanelActions =
  | CloseScopingDialog
  | FocusVehicle
  | FocusAsset
  | OpenScopingDialog
  | SelectVehicle
  | SelectAndFocusVehicle
  | SelectAsset
  | UpdateVehicleSelectionMode;
